import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.AGGREGATE_CARDS].GET_AVAILABLE_AGGREGATE_CARDS]: {
		url: '/telematics/v1/available_aggregate_cards_list/:companyId/', // FIXME: fix url
	},
}
